export const geoApiOptions = {
    method: 'GET',
	headers: {
		'X-RapidAPI-Key': '8bc36e0e9emshd6bb6837242f4fbp10cd8fjsn151b778ebb08',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
    };

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo';
export const Weather_Api_URL = 'https://api.openweathermap.org/data/2.5/';
export const Forecast_Api_URL = 'https://api.openweathermap.org/data/2.5';
export const  Weather_Api_Key = '7de453f30cb10178f0899094c0f9ec7c'


    